// extracted by mini-css-extract-plugin
module.exports = {"title":"PassCodeForm_title__2rB4B","subtitle":"PassCodeForm_subtitle__1Opou","confirmNumber":"PassCodeForm_confirmNumber__1N7fc"};